import { useEffect, useState } from 'react';
import { API_URL } from '../config';
import { useAuth } from '../contexts/AuthContext';

export default function AuthCallback() {
  const { login } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (!token) {
      setError('Missing token');
      return;
    }

    fetch(`${API_URL}/auth/verify`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    })
      .then((res) => {
        if (!res.ok) throw new Error('Invalid or expired link');
        return res.json();
      })
      .then((data) => {
        login(data.token, data.teacher);
        window.history.replaceState({}, '', '/');
      })
      .catch((err) => setError(err.message));
  }, [login]);

  if (error) {
    return (
      <div
        style={{
          minHeight: '100vh',
          background: 'var(--paper)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 32,
        }}
      >
        <div style={{ textAlign: 'center', maxWidth: 420 }}>
          <div className="t-eyebrow" style={{ marginBottom: 12, color: 'var(--vermillion)' }}>
            Sign-in failed
          </div>
          <h1 className="t-display" style={{ marginBottom: 16 }}>Link invalid</h1>
          <p className="t-body" style={{ marginBottom: 24 }}>{error}</p>
          <button className="btn btn--lg" onClick={() => { window.location.href = '/'; }}>
            Try again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--paper)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <div className="t-eyebrow" style={{ marginBottom: 12 }}>Verifying · 验证</div>
        <h1 className="t-display">Signing you in…</h1>
      </div>
    </div>
  );
}
